import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-59855ca1")

_pushScopeId("data-v-59855ca1")
const _hoisted_1 = { class: "image-outline" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_VideoRectOutline = _resolveComponent("VideoRectOutline")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_VideoRectOutline, {
      width: _ctx.elementInfo.width,
      height: _ctx.elementInfo.height,
      radius: _ctx.clipShape.radius,
      outline: _ctx.elementInfo.outline
    }, null, 8, ["width", "height", "radius", "outline"])
  ]))
})